import React from 'react';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { useFormContext } from './FormContext';

interface FormNavigationProps {
  currentPage: number;
  totalPages: number;
  isLastPage: boolean;
  isSubmitting: boolean;
  primaryColor: string;
}

export const FormNavigation: React.FC<FormNavigationProps> = ({
  currentPage,
  totalPages,
  isLastPage,
  isSubmitting,
  primaryColor,
}) => {
  const { actions } = useFormContext();

  return (
    <div className="mt-6 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg p-4 relative z-30">
      <div className="flex justify-between items-center">
        <button
          type="button"
          onClick={actions.previousPage}
          className={`px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center transition-colors ${
            currentPage === 0 ? 'invisible' : ''
          }`}
          style={{ '--tw-ring-color': primaryColor } as React.CSSProperties}
          disabled={currentPage === 0}
        >
          <ChevronLeft className="h-4 w-4 mr-2" />
          Previous
        </button>

        {/* Page indicator */}
        <div className="text-sm text-gray-500">
          Page {currentPage + 1} of {totalPages}
        </div>

        {isLastPage ? (
          <button
            type="button"
            onClick={actions.submitForm}
            disabled={isSubmitting}
            className="px-6 py-2.5 text-white rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center shadow-sm disabled:opacity-70 disabled:cursor-not-allowed transition-opacity"
            style={{
              backgroundColor: primaryColor,
              '--tw-ring-color': primaryColor,
            } as React.CSSProperties}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Submitting...
              </>
            ) : (
              'Submit'
            )}
          </button>
        ) : (
          <button
            type="button"
            onClick={actions.nextPage}
            className="px-4 py-2.5 text-white rounded-lg text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 flex items-center shadow-sm transition-colors"
            style={{
              backgroundColor: primaryColor,
              '--tw-ring-color': primaryColor,
            } as React.CSSProperties}
          >
            Next
            <ChevronRight className="h-4 w-4 ml-2" />
          </button>
        )}
      </div>
    </div>
  );
};